import { useEffect, useRef } from 'react';

import { getSafeMargin } from '../helpers';
import { ChartData } from '../types';

import { drawSvg } from './helpers';
import { ChartLineProps } from './types';

export const useDrawLineChart = ({
  data,
  width,
  height,
  margin,
  ...rest
}: ChartLineProps) => {
  const chartRef = useRef<HTMLDivElement>(null);
  const maxValue = Math.max(...data.map((data: ChartData) => data.value));
  const safeMargin = getSafeMargin(margin);

  const drawProps = {
    data,
    width,
    height,
    chartRef,
    maxValue,
    margin: safeMargin,
    ...rest
  };

  useEffect(() => {
    drawSvg(drawProps);
  }, [data, width, height]);

  return chartRef;
};
